export default () => ({
  pronoun: {
    color: '#999',
    fontSize: '80%',
  },
});
